import NightWorkForMinors from './NightWorkForMinors';

export default NightWorkForMinors;
